import { FC, useState } from 'react'
import styled from 'styled-components'

const MedalistPhase2Card: FC<IMedalistUI> = ({ name, ...props }) => {
  const [visible, setVisible] = useState(false)
  return (
    <StyledMedallist
      onMouseOver={() => setVisible(true)}
      onMouseLeave={() => setVisible(false)}
      {...props}
    >
      <img src={props.$medalistImage} alt={name} className='image' />
      {/* Coming Soon the Image from NextJS */}
      {/* <Image
        src={props.$medalistImage}
        alt={name}
        layout='fill'
        objectFit='cover'
      /> */}
      <div className={`hidden overlay ${visible ? 'lg:flex' : ''}`}>
        {name}
      </div>
      <div className='font-abcd uppercase text-[10px] lg:hidden mt-1 text-[10px] md:text-[20px]'>{name}</div>
    </StyledMedallist>)
}

interface IMedalistUI {
  name: string
  $medalistImage: string
}

const StyledMedallist = styled.div<any>`
  position: relative;
  margin: 0 auto;
  text-align: center;

  img.image {
    margin: 0 auto;
    width: 100%;
  }

  div.overlay {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    color: white;
    align-items: center;
    justify-content: center;
    font-weight: 800;
    font-family: var(--abcdfont);
    text-transform: uppercase;
    
  }

  div.name {
    text-align: center;
  }
`

export default MedalistPhase2Card